import { RefObject, useMemo, useRef, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TwoColTemplate from '@gym-templates/TwoColTemplate/TwoColTemplate';
import { AlertType } from '@gym-atoms/Alert/Alert';
import { Card } from 'primereact/card';
import { useAppSelector } from '@gym-redux/store';
import GymChainProgramAccessCategoryInfoTemplate from '../../templates/GymChainProgramAccessCategoryInfo/GymChainProgramAccessCategoryInfo';
import { GymChainProgramAccessCategory } from '../../../particles/types/GymChainProgramAccessCategory';

const MainColumn = (props: { alertRef: RefObject<AlertType> }) => {
  const { gymChainProgramAccessCategoryId, chainId } = useParams<{
    gymChainProgramAccessCategoryId: string;
    chainId: string;
  }>();
  console.log(gymChainProgramAccessCategoryId, chainId);

  const gymChainProgramAccessCategory = useAppSelector((state) =>
    state.gymChainProgramAccessCategories.items
      .find((g) => g.siteId === +chainId)
      ?.items.find((g) => g.id === +gymChainProgramAccessCategoryId)
  );
  console.log({ gymChainProgramAccessCategory });
  const { t } = useTranslation();
  const [
    gymChainProgramAccessCategoryState,
    setGymChainProgramAccessCategoryState
  ] = useState<GymChainProgramAccessCategory>();

  const createGymChainProgramAccessCategory = async () => {
    const items = {
      id: gymChainProgramAccessCategory?.id || 0,
      siteId: gymChainProgramAccessCategory?.siteId || 0,
      name: gymChainProgramAccessCategory?.name || '',
      gender: gymChainProgramAccessCategory?.gender || '',
      age: gymChainProgramAccessCategory?.age || 0,
      schedulesOnly: gymChainProgramAccessCategory?.schedulesOnly ? 'true' : 'false',
      status: gymChainProgramAccessCategory?.status || '',
      programs: [],
      arxAccessCategoryId: gymChainProgramAccessCategory?.arxAccessCategoryId || ''
    };
    console.log({ items });

    setGymChainProgramAccessCategoryState(items);
  };

  useMemo(() => {
    createGymChainProgramAccessCategory();
  }, []);

  return (
    <Card className="pt30 pl40 pr40 pb30">
      <GymChainProgramAccessCategoryInfoTemplate
        alertRef={props.alertRef}
        alertMessage={t('MODIFY_MEMBERSHIP.ALERT_MESSAGE_SUCCESS')}
        programAccessCategory={gymChainProgramAccessCategoryState}
        type={'modify'}
      />
    </Card>
  );
};

const ModifyGymChainProgramAccessCategoryPage = () => {
  const { t } = useTranslation();
  const alertRef = useRef<AlertType>(null);
  const history = useHistory();
  const { chainId } = useParams<{ chainId: string }>();

  return (
    <TwoColTemplate
      title={t('MODIFY_GYM_ACCESS_CATEGORY.PAGE_TITLE')}
      gymChainId={+chainId}
      col1={<MainColumn alertRef={alertRef} />}
      alertRef={alertRef}
      backButtonHandler={() => history.push(`/gymChains/${chainId}/gymChainAccessCategories`)}
    />
  );
};
export default ModifyGymChainProgramAccessCategoryPage;
